<template>
    <va-edit-layout>
        <AdjustmentEventItem-form
            :id="id"
            :title="title"
            :item="item"
        ></AdjustmentEventItem-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
